// extracted by mini-css-extract-plugin
export var outOfStockLabel = "OutOfStockLabel-module--outOfStockLabel--842b9";